import { VideoPlayer } from "@ui/components/demos/VideoToMusic/components/VideoPlayer";

interface VideoPreviewProps {
  loop?: boolean;
  onVideoPause?: () => void;
  onVideoPlay?: () => void;
  onVideoSeeked?: () => void;
  onVideoTimeUpdate?: () => void;
  videoRef?: React.RefObject<HTMLVideoElement | null>;
  videoUrl?: null | string;
}

export function VideoPreview({
  videoRef,
  videoUrl,
  onVideoSeeked,
  onVideoTimeUpdate,
  onVideoPlay,
  onVideoPause,
  loop = true,
}: VideoPreviewProps) {
  return (
    <div className='h-full space-y-16 overflow-hidden'>
      <div className='flex-column group relative flex h-full items-center justify-center overflow-hidden'>
        <VideoPlayer
          className='h-full w-full'
          loop={loop}
          onPause={onVideoPause}
          onPlay={onVideoPlay}
          onSeeked={onVideoSeeked}
          onTimeUpdate={onVideoTimeUpdate}
          ref={videoRef}
          src={videoUrl}
        />
      </div>
    </div>
  );
}
